<script setup lang="ts">
import {
  Fold,
  Expand,
  Coin,
  User,
  Headset,
  FolderOpened,
  Mic,
  TakeawayBox,
  Message,
  Tickets,
  ChatDotSquare,
  Platform,
  Setting,
  VideoCamera,
  Goods,
  HomeFilled,
} from '@element-plus/icons-vue'
import { useUserStoreHook } from '@/store/modules/user'
import { UserRoleEnum } from '@/types/constantsEnum'
const { isCollapse } = inject('isCollapse') as { isCollapse: boolean }
</script>
<template>
  <el-aside
    :width="isCollapse ? '64px' : '180px'"
    class="transition-all duration-300 border-r px-[10px]"
  >
    <div class="h-[60px] flex items-center justify-center">
      <h1 class="text-xl font-bold" v-show="!isCollapse">
        {{ isCollapse ? 'AI' : 'AI Music' }}
      </h1>
    </div>

    <el-menu
      router
      :default-active="$route.path"
      :collapse="isCollapse"
      class="border-none"
      unique-opened
    >
      <el-menu-item index="/admin/index">
        <el-icon><HomeFilled /></el-icon>
        <template #title>首页</template>
      </el-menu-item>
      <el-menu-item index="/admin/user">
        <el-icon><User /></el-icon>
        <template #title>用户管理</template>
      </el-menu-item>
      <el-sub-menu index="/admin/integral">
        <template #title>
          <el-icon><Coin /></el-icon>
          <span>积分管理</span>
        </template>
        <el-menu-item index="/admin/integral">
          <template #title>基础配置</template>
        </el-menu-item>
        <el-menu-item index="/admin/integral/record">
          <template #title>积分记录</template>
        </el-menu-item>
        <el-menu-item
          index="/admin/integral/add"
          v-if="useUserStoreHook().roles.includes(UserRoleEnum.Admin)"
        >
          <template #title>添加积分</template>
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/admin/package">
        <template #title>
          <el-icon><Message /></el-icon>
          <span>套餐配置</span>
        </template>
        <el-menu-item index="/admin/package">
          <template #title>积分套餐</template>
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item index="/admin/order">
        <el-icon><Tickets /></el-icon>
        <template #title>订单管理</template>
      </el-menu-item>
      <el-menu-item index="/admin/music">
        <el-icon><Headset /></el-icon>
        <template #title>音乐管理</template>
      </el-menu-item>
      <el-sub-menu index="/admin/mvproject">
        <template #title>
          <el-icon><VideoCamera /></el-icon>
          <span>视频管理</span>
        </template>
        <el-menu-item index="/admin/mvproject">
          <template #title>项目列表</template>
        </el-menu-item>
        <el-menu-item index="/admin/exportmv">
          <template #title>合成视频</template>
        </el-menu-item>
        <el-menu-item index="/admin/segment">
          <template #title>创作视频</template>
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item index="/admin/voice">
        <el-icon><Mic /></el-icon>
        <template #title>声线克隆</template>
      </el-menu-item>
      <el-menu-item index="/admin/material">
        <el-icon><FolderOpened /></el-icon>
        <template #title>素材管理</template>
      </el-menu-item>
      <el-sub-menu index="/admin/agreement">
        <template #title>
          <el-icon><Platform /></el-icon>
          <span>网站配置</span>
        </template>
        <el-menu-item index="/admin/agreement">
          <template #title>协议管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/base_config">
          <template #title>基础配置</template>
        </el-menu-item>
      </el-sub-menu>

      <el-sub-menu index="/admin/integral">
        <template #title>
          <el-icon><TakeawayBox /></el-icon>
          <span>任务管理</span>
        </template>
        <el-menu-item index="/admin/music_task">
          <template #title>音乐创作任务</template>
        </el-menu-item>
        <el-menu-item index="/admin/ai_task">
          <template #title>AI演唱任务</template>
        </el-menu-item>
        <el-menu-item index="/admin/mv_task">
          <template #title>视频创作任务</template>
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/admin/inspiration">
        <template #title>
          <el-icon><ChatDotSquare /></el-icon>
          <span>文本管理</span>
        </template>
        <el-menu-item index="/admin/inspiration">
          <template #title>灵感文本</template>
        </el-menu-item>
        <el-menu-item index="/admin/promptType">
          <template #title>提示词分类</template>
        </el-menu-item>
        <el-menu-item index="/admin/prompt">
          <template #title>提示词列表</template>
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/admin/system_config">
        <template #title>
          <el-icon><Setting /></el-icon>
          <span>系统管理</span>
        </template>
        <!-- <el-menu-item index="/admin/role">
          <template #title>角色管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/permission">权限管理</el-menu-item> -->
        <el-menu-item
          index="/admin/system_config"
          v-if="useUserStoreHook().roles.includes(UserRoleEnum.Admin)"
        >
          <template #title>系统配置</template>
        </el-menu-item>
        <el-menu-item
          index="/admin/platforms"
          v-if="useUserStoreHook().roles.includes(UserRoleEnum.Admin)"
        >
          <template #title>三方配置</template>
        </el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/admin/rebate">
        <template #title>
          <el-icon><Goods /></el-icon>
          <span>佣金管理</span>
        </template>
        <el-menu-item index="/admin/rebate">
          <template #title>佣金配置</template>
        </el-menu-item>
        <el-menu-item index="/admin/rebate/history">提现记录</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/admin/chat">
        <template #title>
          <el-icon><ChatDotSquare /></el-icon>
          <span>AI 对话管理</span>
        </template>
        <el-menu-item index="/admin/chat/llmodel">
          <template #title>LLModel 管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/chat/conversations">
          <template #title>用户对话</template>
        </el-menu-item>
        <el-menu-item index="/admin/chat/usage">
          <template #title>用量报表</template>
        </el-menu-item>
      </el-sub-menu>
    </el-menu>
  </el-aside>
</template>
<style lang="scss" scoped>
:deep(.el-menu) {
  border-right: none;

  .el-menu-item {
    border-radius: 4px;

    &.is-active {
      background: var(--home-aisound-btn) !important;
      color: #fff !important;

      .el-icon {
        color: #fff !important;
      }
    }

    &:hover {
      background-color: var(--el-color-primary-light-9);
      color: var(--theme-color);
    }
  }

  .el-sub-menu {
    .el-menu-item {
      border-radius: 4px;
      &.is-active {
        background: var(--home-aisound-btn) !important;
        color: #fff !important;

        .el-icon {
          color: #fff !important;
        }
      }
    }
  }
}

// 子菜单标题样式
:deep(.el-sub-menu__title) {
  &:hover {
    background-color: var(--el-color-primary-light-9) !important;
    color: var(--theme-color) !important;
  }
}
</style>
